import { fromJS } from "immutable";
import { name } from "./__init__";
import { Configurer } from "../../containers/App";
import { selectors as appSelectors } from "../../containers/App";
import { convertRawARIDataToStandardFormat, convertStandardFormatToCalendarFormat } from "./util"; // eslint-disable-line
import { Map } from "immutable"; // eslint-disable-line
import {
  fetchARI,
  buildARIRequestParams,
  buildQueryTrackData,
} from "../../containers/App/configurer";
import { name as appName } from "../../containers/App/__init__";
import constants from "../../utils/constants";

import { requestCalendarARI as apiRequestCalendarARI } from "../../utils/witbookingApi";
import { addDays } from "../../utils/date";
import { sendQuery } from "../../utils/EngineDataColllector/EngineDataCollector";

const LOAD_CALENDAR_ARI = `${name}/LOAD_CALENDAR_ARI`;
const LOAD_CALENDAR_ARI_SUCCESS = `${name}/LOAD_CALENDAR_ARI_SUCCESS`;
const LOAD_CALENDAR_ARI_ERROR = `${name}/LOAD_CALENDAR_ARI_ERROR`;

const LOAD_FULL_CALENDAR_ARI = `${name}/LOAD_FULL_CALENDAR_ARI`;
const LOAD_FULL_CALENDAR_ARI_SUCCESS = `${name}/LOAD_FULL_CALENDAR_ARI_SUCCESS`;
const LOAD_FULL_CALENDAR_ARI_ERROR = `${name}/LOAD_FULL_CALENDAR_ARI_ERROR`;

const INITIAL_LOAD = `${name}/INITIAL_LOAD`;

const SET_DATE = `${name}/SET_DATE`;

export const initialState = fromJS({
  data: false,
  fullARIForSelectedCalendarDates: false,
  calendarARI: false,
  loading: false,
  fullCalendarARILoading: false,
  error: false,
  loaded: false,
  from: null,
  to: null,
});

export default (state = initialState, action) => {
  switch (action.type) {
    case LOAD_CALENDAR_ARI_SUCCESS: {
      const calendarRawData = action.result;
      const calendarARI = convertRawARIDataToStandardFormat({
        rawData: calendarRawData.data,
        startDate: calendarRawData.start,
      });
      const calendarData = convertStandardFormatToCalendarFormat(calendarARI);
      let nextState = state;
      if (!state.get("data")) {
        nextState = nextState.set("data", new Map());
      }
      if (!state.get("calendarARI")) {
        nextState = nextState.set("calendarARI", new Map());
      }
      return nextState
        .setIn(
          [
            "data",
            action.result.propertyTicker,
            action.result.ticker || action.result.propertyTicker,
          ],
          calendarData
        )
        .setIn(
          [
            "calendarARI",
            action.result.propertyTicker,
            action.result.ticker || action.result.propertyTicker,
          ],
          calendarARI
        )
        .set("loading", false)
        .set("loaded", true);
    }
    case LOAD_CALENDAR_ARI_ERROR:
      return state.set("error", action.error).set("loading", false).set("loaded", true);
    case LOAD_CALENDAR_ARI:
      return state.set("loaded", false).set("loading", true);
    case INITIAL_LOAD:
      return state
        .set("fullARIForSelectedCalendarDates", action.data)
        .set("from", new Map().set(action.propertyTicker, action.from))
        .set("to", new Map().set(action.propertyTicker, action.to));
    case LOAD_FULL_CALENDAR_ARI_SUCCESS:
      // TODO: Probably we should merge the individual ARI with a global ARI
      // For example in a chain we will have ARIs for multiple hotels
      // We just need to replace the current value of the ARI for the calendar hotel
      // and leave the rest as they are.
      const callingTicker = action.result && action.result.callingTicker;
      if (
        !action.result ||
        !action.result.data ||
        !callingTicker ||
        !action.result.data[callingTicker]
      ) {
        return state
          .set("error", action.error)
          .set("fullCalendarARILoading", false)
          .set("loaded", true);
      }
      const callingPropertyAri = fromJS(action.result.data);
      const mergeResult = state.get("fullARIForSelectedCalendarDates").merge(callingPropertyAri);
      return state
        .set("fullARIForSelectedCalendarDates", mergeResult)
        .set("error", false)
        .set("fullCalendarARILoading", false);
    case LOAD_FULL_CALENDAR_ARI_ERROR:
      return state.set("error", action.error).set("fullCalendarARILoading", false);
    case LOAD_FULL_CALENDAR_ARI:
      return state.set("fullCalendarARILoading", true);
    case SET_DATE:
      let stateResult = state;
      if (action.hasOwnProperty("from")) {
        stateResult = stateResult.setIn(["from", action.propertyTicker], action.from);
      }
      if (action.hasOwnProperty("to")) {
        stateResult = stateResult.setIn(["to", action.propertyTicker], action.to);
      }
      return stateResult;
    default:
      return state;
  }
};

export function setDate({ to, from, propertyTicker }) {
  return {
    type: SET_DATE,
    propertyTicker,
    to,
    from,
  };
}

export function initialFullCalendarAriLoad({ from, to, propertyTicker }) {
  return (dispatch, getState) => {
    const data = getState()[appName].get(constants.PROPERTY_ARI_KEY);
    return dispatch({
      type: INITIAL_LOAD,
      propertyTicker,
      data,
      from,
      to,
    });
  };
}

export function requestFullARIForSelectedCalendarDates({
  propertyTicker,
  callingTicker,
  newConfiguration,
}) {
  return (dispatch, getState) => {
    const oldConfiguration = getState()[appName].get("configuration").toJS();
    const configuration = { ...oldConfiguration, ...newConfiguration };
    const ARIRequestParams = buildARIRequestParams(configuration);
    return dispatch({
      types: [LOAD_FULL_CALENDAR_ARI, LOAD_FULL_CALENDAR_ARI_SUCCESS, LOAD_FULL_CALENDAR_ARI_ERROR],
      promise: () => {
        return fetchARI(propertyTicker, {
          ...ARIRequestParams.localStorage,
          ...ARIRequestParams.sessionStorage,
          ipInfo: configuration.ipInfo,
        })
          .then(data => {
            sendQuery(
              buildQueryTrackData({
                ARI: data,
                ariRequestParams: {
                  ...ARIRequestParams.localStorage,
                  ...ARIRequestParams.sessionStorage,
                },
                configuration,
                propertyTicker,
              })
            ).then(() => console.debug("tracked ARI request"));
            return { data: data, callingTicker };
          })
          .catch(err => {
            console.log("ERROR requestARI");
            console.log(err);
          });
      },
    });
  };
}

// export function requestCalendarARI({propertyTicker, inventoryTicker, cheapestBookable}) {
export function requestCalendarARI({ propertyTicker, inventoryTicker }) {
  return (dispatch, getState) => {
    const configuration = appSelectors.configurationSelector(getState());
    const requestParams = Configurer.buildARIRequestParams(configuration.toJS());
    const localRequestParams = requestParams.localStorage;
    const sessionRequestParams = requestParams.sessionStorage;
    localRequestParams.start = new Date();
    localRequestParams.end = addDays(localRequestParams.start, 548);
    localRequestParams.ticker = inventoryTicker;
    // requestParams.cheapestBookable = cheapestBookable;
    dispatch({
      types: [LOAD_CALENDAR_ARI, LOAD_CALENDAR_ARI_SUCCESS, LOAD_CALENDAR_ARI_ERROR],
      promise: () =>
        apiRequestCalendarARI(
          {},
          {
            propertyTicker,
            ...localRequestParams,
            ...sessionRequestParams,
          }
        ),
    });
  };
}

export const actions = {
  requestCalendarARI,
  requestFullARIForSelectedCalendarDates,
  initialFullCalendarAriLoad,
  setDate,
};
